import {LocalDateTime} from '@js-joda/core';
import {get} from 'lodash-es';

import {events} from '../events';

export const marketAccessExceptionsReducer = {
    [events.MARKET_ACCESS_EXCEPTIONS_GET]: (state) => ({
        ...state,
        error: false,
        isLoading: true
    }),
    [events.MARKET_ACCESS_EXCEPTIONS_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        isLoading: false,
        error: false,
        count: get(data, 'meta.totalRecords', 0),
        rowData: get(data, 'data', []),
        timestamp: LocalDateTime.now()
    }),
    [events.MARKET_ACCESS_EXCEPTIONS_ERROR]: (state, {error}) => ({
        ...state,
        error,
        isLoading: false,
        rowData: [],
        count: 0,
        timestamp: LocalDateTime.now()
    })
};
